import serviceRequest from "utils/request";

const baseUrl = "/api/notification";

export const getNotificationInfo = () => {
	return serviceRequest({
		url: `${baseUrl}/get-notification`,
		method: "get",
	});
};

export const readNotification = (data) => {
	return serviceRequest({
		url: `${baseUrl}/read-notification`,
		method: "post",
		data,
	});
};
